import {
    PackagesPriceTableDataProvider,
    PackagesTablesCheckElementsProvider,
    PackagesDetailsDrawerProvider,
    PackagesCalendarProvider,
    PackagesWeekdayFilterProvider,
    PackagesPriceByNightTablesProvider,
    PackagesPivotProvider,
    PackagesSitesCollapsedProvider,
} from './@contexts'
import React from 'react'

// NOTA: PackagesAnalyzerVsPreviousPriceProvider se monta a NIVEL DE Content/index.jsx (ver
// Content/index.jsx), no aquí, porque las Cards viven fuera del subárbol de Tables y
// también lo consumen.

export default function PackagesTablesProviders({ children }) {

    return <PackagesTablesCheckElementsProvider>
        <PackagesWeekdayFilterProvider>
            <PackagesPriceTableDataProvider>
                <PackagesDetailsDrawerProvider>
                    <PackagesCalendarProvider>
                        <PackagesPriceByNightTablesProvider>
                            <PackagesPivotProvider>
                                <PackagesSitesCollapsedProvider>
                                    {children}
                                </PackagesSitesCollapsedProvider>
                            </PackagesPivotProvider>
                        </PackagesPriceByNightTablesProvider>
                    </PackagesCalendarProvider>
                </PackagesDetailsDrawerProvider>
            </PackagesPriceTableDataProvider>
        </PackagesWeekdayFilterProvider>
    </PackagesTablesCheckElementsProvider>

}

export { PackagesPriceTableDataContext, PackagesDetailsDrawerContext, PackagesTablesCheckElementsContext, PackagesSelectedTabContext, PackagesSelectedTabProvider, PackagesCalendarContext, PackagesWeekdayFilterContext, PackagesPriceByNightTablesContext, PackagesPivotContext, PackagesAnalyzerVsPreviousPriceContext, PackagesAnalyzerVsPreviousPriceProvider, PackagesSitesCollapsedContext } from "./@contexts"